<p-card>
  <div class="not-found-text">
    Die Route: <span class="target-url">{{ targetUrl$ | async }}</span> konnte nicht gefunden werden.
  </div>
  <ng-container *ngIf="defaultStartRoute$ | async as defaultStartRoute">
    <p-button class="back-to-dashboard-button" (click)="navToStartPage(defaultStartRoute)"
      >Zurück zur Startseite</p-button
    >
  </ng-container>
</p-card>
